import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    "data-left-header-navigation": "",
    class: "hidden justify-self-start transition-none lg:block"
};
const _hoisted_2 = {
    key: 0,
    class: "flex gap-6 whitespace-nowrap xl:gap-10"
};
const _hoisted_3 = ["href", "target", "rel"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LeftHeaderNavigation',
    props: {
        navOpen: {
            type: Boolean,
            required: false,
            default: false,
        },
        navigation: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const limitedNavigation = computed(() => {
            // Create an object with the first N properties from the 'navigation' prop
            const limited = {};
            let count = 0;
            for (const key in props.navigation) {
                if (count >= 3)
                    break;
                limited[key] = props.navigation[key];
                count++;
            }
            return limited;
        });
        return (_ctx, _cache) => {
            return (limitedNavigation.value)
                ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                    (!__props.navOpen)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitedNavigation.value, (navItem) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: navItem.objectID,
                                    class: "font-bold text-black"
                                }, [
                                    _createElementVNode("a", {
                                        href: navItem.url,
                                        target: navItem.target || '_self',
                                        class: "",
                                        rel: navItem.target === '_blank'
                                            ? 'noopener noreferrer'
                                            : null
                                    }, _toDisplayString(navItem.label), 9, _hoisted_3)
                                ]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
